import React from 'react';
import images from '../../generated/responsive-images';
import './ResponsiveImage.css';

export default function ResponsiveImage({
  src, alt, sizes = '100vw', coverHeight, loading = 'lazy', decoding = 'async', ...props
}) {
  // macOS may return decomposed accents when scanning filenames, while source
  // imports use composed accents. Both URLs must resolve to the same variants.
  const image = images[typeof src === 'string' ? src.normalize('NFC') : src];
  if (!image) {
    return <img src={src} alt={alt} loading={loading} decoding={decoding} {...props} />;
  }
  const largest = image.candidates[image.candidates.length - 1];
  // A landscape photo covering a tall container is scaled by height before
  // being cropped. Account for that so mobile hero images do not look blurry.
  const imageSizes = coverHeight
    ? `max(${sizes}, calc(${(image.width / image.height).toFixed(5)} * (${coverHeight})))`
    : sizes;
  return (
    <img
      width={image.width}
      height={image.height}
      src={largest.src}
      srcSet={image.candidates.map(candidate => `${candidate.src} ${candidate.width}w`).join(', ')}
      sizes={imageSizes}
      alt={alt}
      loading={loading}
      decoding={decoding}
      {...props}
    />
  );
}

// The parent must be positioned and use isolation:isolate so this image stays
// behind its overlays without escaping the parent's stacking context.
export function BackgroundImage(props) {
  return <ResponsiveImage alt="" aria-hidden="true" {...props} className="responsive-background-image" />;
}
